import { useTranslation } from "react-i18next";
import { Drawer } from "melco-ui";
import { DrawerType, EfsMelcoEfsModelsFormat } from "melco-shared-logic";
import { ChooseDesignList } from "./ChooseDesignList";
import { ServiceType } from "../../helper/serviceType";

type ChooseDesignDrawerProps = {
  drawer: DrawerType;
  onDesignSelect: (selectedDesign: EfsMelcoEfsModelsFormat) => void;
  serviceType: ServiceType;
};

export const ChooseDesignDrawer: React.FC<ChooseDesignDrawerProps> = ({
  drawer,
  onDesignSelect,
  serviceType,
}) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t("designMappings.actions.designConfiguration.chooseDesign.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      <ChooseDesignList
        drawer={drawer}
        onDesignSelect={onDesignSelect}
        serviceType={serviceType}
      />
    </Drawer>
  );
};
